import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { BasicTypeaheadTitle, BloodhoundTitle, CustomTemplatesTitle, FormWidgetsTitle, PrefetchTitle, RTLSupportTitle, RemoteTypeaheadTitle, ScrollableDropdownMenuTitle, TypeaheadTitle } from "../../../../../Constants/Constants";
import { BasicTypeaheadSubTitle, BloodHoundSubTitle, CountryList, CustomTemplateSubTitle, MovieList, OscarWinnersMovieList, PrefetchSubTitle, RTlSupportSubTitle, RemoteTypeaheadSubTitle, ScrollableDropdownSubTitle, StatesOfUSA } from "../../../../../Data/Forms&Table/Forms/FormWidgets";
import CommonTypeahead from "./Common/CommonTypeahead";
import MultipleSectionsWithHeaders from "./MultipleSectionsWithHeaders";
import { Fragment } from "react/jsx-runtime";

const TypeaheadContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TypeaheadTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <div className="typeahead typeahead-wrapper">
          <Row>
            <CommonTypeahead id="basic" title={BasicTypeaheadTitle} subTitle={BasicTypeaheadSubTitle} options={StatesOfUSA} placeholder="States of USA" />
            <CommonTypeahead id="prefetch" title={PrefetchTitle} subTitle={PrefetchSubTitle} options={CountryList} placeholder="Countries" />
            <CommonTypeahead id="blood" title={BloodhoundTitle} subTitle={BloodHoundSubTitle} options={StatesOfUSA} placeholder="States of USA" />
            <CommonTypeahead id="remote" title={RemoteTypeaheadTitle} subTitle={RemoteTypeaheadSubTitle} options={MovieList} placeholder="Choose Option" />
            <CommonTypeahead id="custom" title={CustomTemplatesTitle} subTitle={CustomTemplateSubTitle} options={OscarWinnersMovieList} placeholder="Oscar winners" />
            <MultipleSectionsWithHeaders />
            <CommonTypeahead id="scroll" title={ScrollableDropdownMenuTitle} subTitle={ScrollableDropdownSubTitle} options={CountryList} placeholder="Countries" />
            <CommonTypeahead id="rtl" title={RTLSupportTitle} subTitle={RTlSupportSubTitle} options={CountryList} placeholder="Countries" />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default TypeaheadContainer;
